import axios from "axios";
import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { genURL } from "./../_getjson";
import { AlertPopup, ReDate } from "./AlertPopup";
require("./../_css/PopUpOther.css");

export default class Popup extends React.Component {
  constructor(props) {
    super(props);
    this.Name = React.createRef();
    this.state = {
      TableHidden: true,
      casschkbox: "far fa-square",
      casschkboxs: false,
      casschkbox2: "far fa-square",
      casschkboxs2: false,
    };
  }
  componentDidMount() {
    this.Filter();
  }
  Filter = () => {
    switch (this.props.Title) {
      case "SelPRRef":
        this.setState({
          TxtTitle: "ค้นหาใบขอสั่งซื้อสินค้า " + this.props.Title,
        });
        this.setState({ SERVICE1: "CSPR/CSV_PRREFDOCNO" });
        this.setState({ SERVICE2: "CSPR/CSV_PRREFDOCNOSUB" });
        this.AddValue1("CSPR/CSV_PRREFDOCNO?top=100");
        break;
      default:
        break;
    }
  };
  AddValue1 = (url) => {
    axios.get(genURL(url)).then((res) => {
      var data = res.data;
      var dataAr = [];
      for (var i = 0; i < data.length && data; i++) {
        dataAr[i] = {
          NUMBER: i + 1,
          DOCNO: data[i].DOCNO,
          DOCDATE: ReDate(data[i].DOCDATE),
          REMARK: data[i].REMARK,
          USER: data[i].PRNAME,
          DEPARTMENT: data[i].depname,
          GROUPDATA: data[i].grpname,
          SB: "0",
        };

        if (i === data.length - 1) {
          this.setState({ col1: dataAr });
        }
      }
      this.setState({ TableHidden: true });
    })
  }

  onSubmit = (e) => {
    if (this.state.TableHidden === true) {
      var docno = "";
      for (var i = 0; i < this.state.col1.length; i++) {
        if (this.state.col1[i].SB === "1") {
          docno += "&docno=" + this.state.col1[i].DOCNO;
        }
      }
      if (docno === "") {
        AlertPopup("Warning", "กรุณาเลือกข้อมูลก่อน");
      } else {
        var url = this.state.SERVICE2 + "?top=100" + docno;
        this.AddValue2(url);
      }
    } else {
      var reData = [];
      var sb_length = 0;
      var j = 0;
      for (var i = 0; i < this.state.col2.length && this.state.col2[i].DOCNO; i++) {
        if (this.state.col2[i].SB === "1") {
          sb_length = sb_length + 1;
          reData[j] = {
            NUMBER: this.state.col2[i].NUMBER,
            DOCNO: this.state.col2[i].DOCNO,
            PRODUCTCODE: this.state.col2[i].PRODUCTCODE,
            PRODUCTNAME: this.state.col2[i].PRODUCTNAME,
            UNIT: this.state.col2[i].UNIT,
            UNITCODE: this.state.col2[i].UNITCODE,
            QTY: this.state.col2[i].QTY,
            WHENDATE: this.state.col2[i].WHENDATE,
            USER: this.state.col2[i].USER,
            SB: this.state.col2[i].SB,
            WAREHOUSE: this.state.col2[i].WAREHOUSE,
            LOCATION: this.state.col2[i].LOCATION,
            ITEMTAXTYPE: this.state.col2[i].ITEMTAXTYPE,
            PRODUCTSET: this.state.col2[i].PRODUCTSET,
            REFQTY: this.state.col2[i].REFQTY,
            REFLINEID: this.state.col2[i].REFLINEID,
            REFDOCTYPE: this.state.col2[i].REFDOCTYPE,
          };
          j = j + 1;
        }
      }
      if (reData.length === sb_length) {
        this.props.Get_PopUpRefDocno(reData);
        this.props.closePopup();
      }
    }
  };
  AddValue2 = (url, user) => {
    console.log(genURL(url));
    axios.get(genURL(url)).then((res) => {
      console.log(res.data);
      var data = res.data;
      var dataAr = [];
      for (var i = 0; i < data.length; i++) {
        dataAr[i] = {
          NUMBER: i + 1,
          DOCNO: data[i].DOCNO,
          PRODUCTCODE: data[i].PRODUCTCODE,
          PRODUCTNAME: data[i].PRODUCTNAME,
          UNIT: data[i].UNITNAME,
          UNITCODE: data[i].UNITCODE,
          QTY: data[i].QUANTITY,
          WHENDATE: ReDate(data[i].SHIPDATE),
          USER: user,
          SB: "0",
          WAREHOUSE: data[i].WAREHOUSE,
          LOCATION: data[i].LOCATION,
          ITEMTAXTYPE: data[i].ITEMTAXTYPE,
          PRODUCTSET: data[i].PRODUCTSET,
          REFQTY: data[i].REFQTY,
          REFLINEID: data[i].REFLINEID,
          REFDOCTYPE: data[i].REFDOCTYPE,
        };
      }
      this.setState({ TableHidden: false });
      this.setState({ col2: dataAr });
    });
  };

  onKeyUp = (e) => {
    if (e.key === "Enter") {
      var txt = e.target.value;
      this.getItem(txt);
    }
  };
  onClickSearch = () => {
    var txt = this.Name.current.value
    this.getItem(txt);
  };
  // รีเฟรช table1 table2
  onClickRefresh = () => {
    if (this.state.TableHidden === true) {
      this.Filter();
    } else {
      var url = this.state.url
      this.AddValue2(url);
    }
  };
  // ค้นหา table1 table2
  getItem = (data1) => {
    if (this.state.TableHidden === true) {
      let Url = this.state.SERVICE1 + "?top=500&code=" + data1;
      this.AddValue1(Url);
    } else {
      let Url1 = this.state.SERVICE2 + "?top=500&docno=" + data1;
      this.AddValue2(Url1);
    }
  };

  onSelectRow1 = (row, col, id) => {
    //ส่งกลับเมื่อมีการคลิกเลือกข้อมูล
    if (col > 1) {
      row.SB = "1";
      if (typeof col !== undefined && col > 0) {
        if (this.state.TableHidden) {
          var docno = "";
          for (var i = 0; i < this.state.col1.length; i++) {
            if (this.state.col1[i].SB === "1") {
              docno = docno + "&docno=" + this.state.col1[i].DOCNO;
            }
          }
          console.log(docno);
          var url = this.state.SERVICE2 + "?top=200" + docno;
          this.setState({ url: url })
          this.AddValue2(url);
        } else {
          for (var i1 = 0; i1 < this.state.col2.length; i1++) {
            if (this.state.col2[i1].SB === "1")
              this.props.Get_PopUpRefDocno(this.state.col2[i1]);
            if (i1 === this.state.col2.length - 1) this.props.closePopup();
          }
        }
      }
    }
  };
  onSelectRow2 = (row, col, id) => {
    var reData = [];
    if (col > 1) {
      //เท่ากับเลือกรายการเมื่อคลิกแถว
      row.SB = "1";
      //------------------------
      var j = 0;
      for (var i = 0; i < this.state.col2.length && this.state.col2[i].DOCNO; i++) {
        if (this.state.col2[i].SB === "1") {
          reData[j] = {
            NUMBER: this.state.col2[i].NUMBER,
            DOCNO: this.state.col2[i].DOCNO,
            PRODUCTCODE: this.state.col2[i].PRODUCTCODE,
            PRODUCTNAME: this.state.col2[i].PRODUCTNAME,
            UNIT: this.state.col2[i].UNIT,
            QTY: this.state.col2[i].QTY,
            WHENDATE: this.state.col2[i].WHENDATE,
            /* USER: this.state.col2[i].USER, */
            UNITCODE: this.state.col2[i].UNITCODE,
            SB: this.state.col2[i].SB,
            WAREHOUSE: this.state.col2[i].WAREHOUSE,
            LOCATION: this.state.col2[i].LOCATION,
            ITEMTAXTYPE: this.state.col2[i].ITEMTAXTYPE,
            PRODUCTSET: this.state.col2[i].PRODUCTSET,
            REFQTY: this.state.col2[i].REFQTY,
            REFLINEID: this.state.col2[i].REFLINEID,
            REFDOCTYPE: this.state.col2[i].REFDOCTYPE,
          };
          j = j + 1;
        }
      }
      if (reData.length > 0) {
        this.props.Get_PopUpRefDocno(reData);
        this.props.closePopup();
      }
    }
  };

  cellcheckbok = (cell, row, enumObject, rowIndex) => {
    var btn = this.state.col1[rowIndex].SB;
    var btnShow;
    switch (btn) {
      case "0":
        btnShow = (
          <span>
            <i
              class="far fa-square "
              onClick={this.Update_Status.bind(null, rowIndex, "1")}
            ></i>
          </span>
        );
        break;
      case "1":
        btnShow = (
          <span>
            <i
              class="far fa-check-square"
              onClick={this.Update_Status.bind(null, rowIndex, "0")}
            ></i>
          </span>
        );
        break;
      default:
        btnShow = (
          <span>
            <i class=""> </i>
          </span>
        );
    }
    return <div>{btnShow}</div>;
  };
  cellcheckbok2 = (cell, row, enumObject, rowIndex) => {
    var btn = this.state.col2[rowIndex].SB;
    var btnShow;
    switch (btn) {
      case "0":
        btnShow = (
          <span>
            <i
              class="far fa-square "
              onClick={this.Update_Status2.bind(null, rowIndex, "1")}
            ></i>
          </span>
        );
        break;
      case "1":
        btnShow = (
          <span>
            <i
              class="far fa-check-square"
              onClick={this.Update_Status2.bind(null, rowIndex, "0")}
            ></i>
          </span>
        );
        break;
      default:
        btnShow = (
          <span>
            <i class=""> </i>
          </span>
        );
    }
    return <div>{btnShow}</div>;
  };
  Update_Status = (Row, Status) => {
    if (Status === "ALL") {
      if (this.state.casschkboxs === false) {
        //กด checkbox เลือกทั้งหมด
        this.setState({ casschkbox: "far fa-check-square" });
        this.setState({ casschkboxs: !this.state.casschkboxs });
        var dataArray = this.state.col1;
        for (
          var i = 0;
          i < this.state.col1.length && this.state.col1[i].DOCNO;
          i++
        ) {
          dataArray[i].SB = "1";
        }
        this.setState({ row: dataArray });
      } else {
        //กด checkbox ไม่เลือก
        this.setState({ casschkbox: "far fa-square" });
        this.setState({ casschkboxs: !this.state.casschkboxs });

        var dataArray = this.state.col1;
        for (
          var i = 0;
          i < this.state.col1.length && this.state.col1[i].DOCNO;
          i++
        ) {
          dataArray[i].SB = "0";
        }
        this.setState({ row: dataArray });
      }
    } else {
      //เปลี่ยนสถานะไม่มีการเลือกทั้งหมด (checkbox หัวตาราง) เมื่อมีการติ๊กรายการใดรายการหนึ่งออก
      if (Status === "0") {
        this.setState({ casschkbox: "far fa-square" });
        this.setState({ casschkboxs: false });
      }
      //เปลี่ยนสถานะ เลือก/ไม่เลือก (checkbox แต่ละแถว)
      var dataArray = this.state.col1;
      dataArray[Row].SB = Status;
      this.setState({ col1: dataArray });
      //เปลี่ยนสถานะเลือกทั้งหมด (checkbox หัวตาราง) เมื่อเลือกทุกรายการ
      var sb_length = 0;
      for (
        var i = 0;
        i < this.state.col1.length && this.state.col1[i].DOCNO;
        i++
      ) {
        if (this.state.col1[i].SB === "1") {
          sb_length = sb_length + 1;
        }
      }
      if (sb_length === this.state.col1.length) {
        this.setState({ casschkbox: "far fa-check-square" });
        this.setState({ casschkboxs: true });
      }
    }
  };
  Update_Status2 = (Row, Status) => {
    if (Status === "ALL") {
      if (this.state.casschkboxs2 === false) {
        //กด checkbox เลือกทั้งหมด
        this.setState({ casschkbox2: "far fa-check-square" });
        this.setState({ casschkboxs2: !this.state.casschkboxs2 });
        var dataArray = this.state.col2;
        for (
          var i = 0;
          i < this.state.col2.length && this.state.col2[i].DOCNO;
          i++
        ) {
          dataArray[i].SB = "1";
        }
        this.setState({ row: dataArray });
      } else {
        //กด checkbox ไม่เลือก
        this.setState({ casschkbox2: "far fa-square" });
        this.setState({ casschkboxs2: !this.state.casschkboxs2 });
        var dataArray = this.state.col2;
        for (
          var i = 0;
          i < this.state.col2.length && this.state.col2[i].DOCNO;
          i++
        ) {
          dataArray[i].SB = "0";
        }
        this.setState({ row: dataArray });
      }
    } else {
      console.log(Status);

      //เปลี่ยนสถานะไม่มีการเลือกทั้งหมด (checkbox หัวตาราง) เมื่อมีการติ๊กรายการใดรายการหนึ่งออก
      if (Status === "0") {
        this.setState({ casschkbox2: "far fa-square" });
        this.setState({ casschkboxs2: false });
      }
      //เปลี่ยนสถานะ เลือก/ไม่เลือก (checkbox แต่ละแถว)
      var dataArray = this.state.col2;
      dataArray[Row].SB = Status;
      this.setState({ col2: dataArray });
      //เปลี่ยนสถานะเลือกทั้งหมด (checkbox หัวตาราง) เมื่อเลือกทุกรายการ
      var sb_length = 0;
      for (
        var i = 0;
        i < this.state.col2.length && this.state.col2[i].DOCNO;
        i++
      ) {
        if (this.state.col2[i].SB === "1") {
          sb_length = sb_length + 1;
        }
      }
      if (sb_length === this.state.col2.length) {
        this.setState({ casschkbox2: "far fa-check-square" });
        this.setState({ casschkboxs2: true });
      }
    }
  };
  render() {
    return (
      <div className="popup">

        <div className="popup_inner">

          <div class="PopUpOtherDivH" align="left">
            <div class="PopUpOtherDivH1">
              <i class="fas fa-search"> {this.state.TxtTitle} </i>
            </div>
            <div class="PopUpOtherDivH2" onClick={this.props.closePopup}>
              <i class="fas fa-times"></i>
            </div>
          </div>
          <div class="panel-body divTable" align="right">
            <div class="row">
              {/* <div class="form-group " style={{ float: "right", marginRight: "18px", marginTop: "2px", }} >
                <div class="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <button class="txt-img icon" type="button" style={{ height: "30px" }} onClick={this.onClickRefresh} >
                    <i class="fas fa-sync-alt" style={{ fontSize: "15px", marginTop: "-30px" }}></i>
                  </button>
                </div>
              </div> */}
              <div class="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4" style={{ float: "right" }}>
                <div class="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                  <input type="text" class="form-control" placeholder="ค้นหาเลขที่เอกสาร" onKeyUp={this.onKeyUp} ref={this.Name} />
                  <span class="input-group-addon txt-img icon">
                    <i class="fas fa-search" onClick={this.onClickSearch}></i>
                  </span>
                  <span class="input-group-addon txt-img icon">
                    <i class="fas fa-sync-alt" style={{ fontSize: "15px", marginTop: "3px" }} onClick={this.onClickRefresh}></i>
                  </span>
                </div>
              </div>
            </div>
            <div /* class="DivTable" */ hidden={!this.state.TableHidden} style={{ marginTop: "10px" }}>
              <BootstrapTable
                data={this.state.col1}
                height="520"
                options={{ onRowClick: this.onSelectRow1, noData: "....", }}
                hover condensed /* search */
                /* searchPlaceholder='input something...' */
                scrollTop={'Bottom'}
              >
                <TableHeaderColumn columnClassName="columnAll columnID" className="columnID" expandable={true} dataAlign="center" width="35" dataField="NUMBER" dataSort></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="35" dataField="SB" editable={false} dataAlign="center" dataFormat={this.cellcheckbok.bind(this)}>  <div onClick={this.Update_Status.bind(null, "", "ALL")}>    <i class={this.state.casschkbox}    ></i>  </div></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField="DOCNO" width="130" isKey dataSort>  เลขที่เอกสาร</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField="DOCDATE" dataSort>  วันที่เอกสาร</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField="REMARK" columnTitle dataSort>  หมายเหตุ</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField="USER" dataSort>  พนักงาน</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField="DEPARTMENT" dataSort>  แผนก</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField="GROUPDATA" columnTitle dataSort>  กลุ่มข้อมูล</TableHeaderColumn>
              </BootstrapTable>
            </div>

            <div /* class="DivTable" */ hidden={this.state.TableHidden}>
              <BootstrapTable 
              data={this.state.col2} height="520" 
              options={{ onRowClick: this.onSelectRow2, noData: "....", }}
               hover condensed /* search */>
                <TableHeaderColumn columnClassName="columnAll columnID" className="columnID" expandable={true} dataAlign="center" width="35" dataField="NUMBER" dataSort></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="35" dataField="SB"
                  editable={false} dataAlign="center" dataFormat={this.cellcheckbok2.bind(this)}> <div onClick={this.Update_Status2.bind(null, "", "ALL")}>
                    <i class={this.state.casschkbox2}></i> </div>
                </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnID" width="100" dataField="DOCNO" isKey dataSort>  เลขที่เอกสาร</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnID" width="100" dataField="PRODUCTCODE" dataSort>  รหัสสินค้า</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnID" width="100" dataField="PRODUCTNAME" dataSort>  ชื่อสินค้า</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnID" width="80" dataField="UNIT" dataSort>  หน่วย</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnID" width="80" dataField="QTY" dataSort>  ปริมาณ</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnID" width="100" dataField="WHENDATE" dataSort>  วันที่ต้องการ</TableHeaderColumn>
                {/* <TableHeaderColumn columnClassName="columnAll" className="columnID" dataField="USER" dataSort>  พนักงาน</TableHeaderColumn> */}
              </BootstrapTable>
            </div>
            {this.state.TableHidden ? ("") : (
              <button class="PUSDbtn" onClick={(e) => { this.setState({ TableHidden: true }); }}>
                <i class="fas fa-reply-all"> กลับ </i>
              </button>
            )}
            <button class="PUSDbtn" onClick={this.onSubmit}>
              <i class="fas fa-check"> ตกลง </i>
            </button>
          </div>
        </div>
      </div>
    );
  }
}
